<template>
  <div class="review-appointment--summary">
    <div class="review-appointment--date">
      <v-layout>
        <v-flex class="review-appointment--date-title" xs12 md9>
          {{date(selectedDate)}}
        </v-flex>
        <v-flex xs12 md3 text-xs-right>
          <EditButton @click="goToScheduleStep" />
        </v-flex>
      </v-layout>
    </div>

    <div class="review-appointment--summary-meta">
      <SummaryRow label="Time" :value="simpleTime(selectedTime)"/>
      <SummaryRow label="Inspector" :value="selectedInspector"/>
    </div>

    <div class="review-appointment--address">
      <v-layout>
        <v-flex xs12 md9>
          <FormattedAddress
            :street="location.address1"
            :street-2="location.address2"
            :city="location.city"
            :state="location.state"
            :postal-code="location.postalCode" />
        </v-flex>
        <v-flex xs12 md3 text-xs-right>
          <EditButton @click="goToPropertyStep" />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Mixins } from '@spectorasoftware/homegauge-vue';

import EditButton from '@/components/common/EditButton.vue';
import FormattedAddress from '@/components/common/FormattedAddress.vue';
import SummaryRow from '@/components/common/SummaryRow.vue';
import StepUtilities from '@/router/utilities/step-utilities';

const { DateTime } = Mixins;

export default {
  components: {
    EditButton,
    FormattedAddress,
    SummaryRow,
  },
  mixins: [DateTime],
  computed: {
    ...mapState('Appointment', {
      location: state => state.locationComponentData,
      selectedDate: state => state.dateComponentData.chosenDate,
      selectedInspector: state => state.dateComponentData.fullName,
      selectedTime: state => state.dateComponentData.time,
    }),
  },
  methods: {
    goToPropertyStep() {
      StepUtilities.goToPropertyStep(this.$router);
    },
    goToScheduleStep() {
      StepUtilities.goToScheduleStep(this.$router);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/components/review';
@import '../styles/vars/theme';

$_row-vertical-padding: 0.675rem;

.review-appointment {
  &--address {
    padding: ($review-summary-padding * 1.2) 0 0;

    p {
      margin: 0;
    }
  }

  &--date {
    &-title {
      @include review-summary-title;
    }
  }

  &--summary {
    @include review-summary;

    &-meta {
      border-bottom: 1px solid lighten($theme-color-gray, 38.82);
      padding: ($review-summary-padding * 1.1) 0;
    }

    .summary-row {
      padding: $_row-vertical-padding 0;
    }
  }
}
</style>
